import { createModalPlaceholder } from "../bootstrap-helpers";

// Global variables
const videoPlaceholder = document.querySelectorAll(".productpage-video-placeholder") || false;

/* 'Lazyload' for iFrame */
export const productVideoLazyLoad = (() => {
	// If there are no placeholders, return
	if (!videoPlaceholder || videoPlaceholder.length == 0) return;

	// Prepare observer
	let options = {
		root: null, // Means viewport
		rootMargin: "0px 0px 100px 0px", // Load when 250px from viewport
	};

	let observer = new IntersectionObserver(iFrameCallback, options);

	// Prepare observer
	videoPlaceholder.forEach((instance) => {
		// Make sure the data-Src is set, otherwise we won't need this function
		if (instance.dataset.videoSrc !== null) {
			// Observe the instance
			observer.observe(instance, options);
		}
	});
})();

function iFrameCallback(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			// Prepare iFrame
			let video = document.createElement("iframe");
			video.src = `https://www.youtube.com/embed/${entry.target.dataset.videoSrc}`;
			video.width = "100%";
			video.height = "100%";
			video.frameborder = "0";

			entry.target.appendChild(video);
			observer.unobserve(entry.target);
		}
	});
}

/* Images in lightbox */
export const productPageImageLightBox = (() => {
	const productImagesElement = document.querySelector(".single-product .product:not(.coming-soon) .product-image-swiper") || false;

	if (!productImagesElement) return;

	// Create the lightbox
	const lightbox = createModalPlaceholder("lightbox");

	// Open the image in lightbox
	productImagesElement.addEventListener("click", (e) => {
		if (e.target.nodeName == "IMG") {
			let image = e.target.outerHTML;
			lightbox._element.querySelector(".modal-body").innerHTML = image;
			lightbox._element.querySelector(".modal-dialog").style.maxWidth = "max-content";

			lightbox.show();
		}
	});
})();

export const toggleInciDescription = (function () {
	const ingredients = [...document.querySelectorAll("#ingredienten .ingredient-wrapper")] || false;

	// Return if not there
	if (!ingredients || ingredients.length < 1) return;

	// Preset modal with type badge
	const modal = createModalPlaceholder("ingredientsModal", { modalHeader: "Ingredient", modalFooter: true }, false);
	const typeBadge = document.createElement("div");
	typeBadge.classList.add("badge", "bg-primary");
	document.querySelector("#ingredientsModal .modal-header").append(typeBadge);

	// Do the work
	ingredients.forEach((ingredient) => {
		ingredient.addEventListener("click", function (e) {
			e.stopPropagation();

			// Set variables
			let nameEl = ingredient.querySelector(".inci-name");
			let name = nameEl.textContent;
			let nameLatin = nameEl.dataset.ingredientName;
			let description = ingredient.querySelector(".inci-description");
			let type = ingredient.querySelector(".ingredient-type");

			// Format type variable
			type = type.innerText.replace("_", " ");
			type = type.charAt(0).toUpperCase() + type.slice(1);

			// Set content and output
			typeBadge.textContent = type;
			if (type === "Allergenen") {
				typeBadge.classList.remove("d-none");
			} else {
				typeBadge.classList.add("d-none");
			}

			modal._element.querySelector(".modal-title").innerText = `${name} (${nameLatin})`;
			modal._element.querySelector(".modal-body").innerHTML = description.innerHTML;

			modal.toggle();
		});
	});
})();

// Variables
const form = document.querySelector("form.variations_form");

// Change variation image
export const variationImage = (() => {
	if (form == null) {
		return;
	}
	const variationSelect = form.querySelector("table.variations select");
	const atts = JSON.parse(form.getAttribute("data-product_variations"));

	// Set original image (will be the first image in the slider)
	const originalImage = document.querySelector(".product-image-swiper .swiper-slide img");

	// Listen for Woocommerce event
	variationSelect.addEventListener("change", () => {
		// Get selected index
		let selection = variationSelect.options[variationSelect.selectedIndex].value;

		let selectionIndex = atts.findIndex((obj) => obj.attributes.attribute_versie === selection);

		if (selectionIndex == -1) {
			replaceProductImageWith(originalImage);

			return;
		}

		// If not returned, use index to search attributes
		let selectionImage = atts[selectionIndex].image;

		// Create variation image
		let variationImage = document.createElement("img");

		// Build Image
		variationImage.title = selectionImage.title;
		variationImage.src = selectionImage.src;
		variationImage.srcset = selectionImage.srcset;
		variationImage.sizes = selectionImage.sizes;

		// Replace the image
		replaceProductImageWith(variationImage);
	});
})();

function replaceProductImageWith(replacementImage) {
	// Get swiper instance
	const productImageSwiper = document.querySelector(".product-image-swiper").swiper;
	// Set image container
	const imageContainer = document.querySelector(".product-image-swiper .product-image-container");

	// Set the image to replace
	let imageToReplace = imageContainer.querySelector("img");

	// Set event listener
	imageContainer.addEventListener(
		"transitionend",
		() => {
			imageToReplace.replaceWith(replacementImage);
			// Fade in (will come after fade out below)
			imageContainer.classList.add("show");

			if (productImageSwiper) productImageSwiper.slideTo(0);
		},
		{ once: true }
	);

	// Fade out
	imageContainer.classList.remove("show");
}
